import { useState, useEffect } from "react";
import { useRelayEnvironment } from "react-relay";
import { graphql, fetchQuery, requestSubscription } from "relay-runtime";
import { useChatUnreadCountQuery } from "./__generated__/useChatUnreadCountQuery.graphql";
import { useChatUnreadCountSubscription } from "./__generated__/useChatUnreadCountSubscription.graphql";

const UnreadCountQuery = graphql`
  query useChatUnreadCountQuery {
    channelsUnreadCount
  }
`;

const UnreadCountSubscription = graphql`
  subscription useChatUnreadCountSubscription {
    channelsUnreadCountSubscription
  }
`;

interface UseChatUnreadCountOptions {
  onUpdate?: () => void;
}

export function useChatUnreadCount(options?: UseChatUnreadCountOptions) {
  const { onUpdate } = options ?? {};
  const [totalUnreadCount, setTotalUnreadCount] = useState(0);
  const environment = useRelayEnvironment();

  // Initial fetch
  useEffect(() => {
    const subscription = fetchQuery<useChatUnreadCountQuery>(
      environment,
      UnreadCountQuery,
      {},
    ).subscribe({
      next: (data) => {
        setTotalUnreadCount(data.channelsUnreadCount ?? 0);
      },
    });
    return () => subscription.unsubscribe();
  }, [environment]);

  // Real-time subscription
  useEffect(() => {
    const subscription = requestSubscription<useChatUnreadCountSubscription>(
      environment,
      {
        subscription: UnreadCountSubscription,
        variables: {},
        onNext: (response) => {
          if (response?.channelsUnreadCountSubscription !== undefined) {
            setTotalUnreadCount(response.channelsUnreadCountSubscription);
            onUpdate?.();
          }
        },
      },
    );
    return () => subscription.dispose();
  }, [environment, onUpdate]);

  return totalUnreadCount;
}
